import { Component, Input, Output, EventEmitter } from '@angular/core';

export class HhsgSharedHeaderMenuLink {
  name: string = '';
  iconClass?: string = '';
  route?: string = '';
  isExternalRoute?: boolean = false;
  fragment?: string = '';
  menuLinks?: HhsgSharedHeaderMenuLink[] = new Array<HhsgSharedHeaderMenuLink>();
}

@Component({
  selector: 'div[hhsg-header-menu]',
  templateUrl: './header-menu.component.html'
})
export class HhsgSharedHeaderMenuComponent {
  @Input() headerLinks: HhsgSharedHeaderMenuLink[];
  @Input() sectionLinks: HhsgSharedHeaderMenuLink[];
  @Input() applicationLinks: HhsgSharedHeaderMenuLink[] = [];
  @Input() isMobile: boolean;

  @Output() closeMenu = new EventEmitter<void>();

  isMobileApp(): boolean {
    return this.isMobile;
  }

}
